import classNames from 'classnames';
import { useState } from 'react';
import { MdMenu, MdStar } from 'react-icons/md';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import TextArea from './form/FormikTextArea';
import { splitCSV } from '../utils';
const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',

    // change background colour if dragging
    background: isDragging ? 'lightgreen' : '',
    padding: '0',
    // styles we need to apply on draggables
    ...draggableStyle
});

const SkuListEditor = ({ skus = [], ranked = false, onChange = () => {} }) => {
    const [newSku, setNewSku] = useState('');

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };
    const onSkusDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        let items = reorder(skus, result.source.index, result.destination.index);

        onChange({ sku_list: items, ranked: ranked });
    };

    const handleRemoveSku = (sku) => {
        let newSkus = skus.filter((s) => s !== sku);
        onChange({ sku_list: newSkus });
    };

    const handleRemoveAll = () => {
        if (
            window.confirm(
                'Are you sure you want to remove all SKUs from this list? This wont take effect until you publish.'
            )
        ) {
            onChange({ sku_list: [] });
        }
    };

    return (
        <div>
            <DragDropContext onDragEnd={onSkusDragEnd} isDropDisabled={!ranked}>
                <Droppable droppableId={`skus`} isDropDisabled={!ranked}>
                    {(provided, snapshot) => (
                        <ul className="list-flat" {...provided.droppableProps} ref={provided.innerRef}>
                            {skus.map((sku, index) => (
                                <Draggable
                                    key={`skus[${index}]`}
                                    draggableId={`skus:${index}`}
                                    index={index}
                                    isDragDisabled={!ranked}
                                >
                                    {(provided, snapshot) => (
                                        <li
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                                        >
                                            {ranked && <MdMenu />} {sku}{' '}
                                            <button
                                                className="button btn-link txt-danger txt-3"
                                                onClick={() => handleRemoveSku(sku)}
                                            >
                                                Remove
                                            </button>
                                        </li>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>

            {!!skus?.length && (
                <button className="button button-danger btn-sm mb-4" type="button" onClick={handleRemoveAll}>
                    Remove All
                </button>
            )}

            <div className="row middle-xs">
                <div className="col-xs-12 col-md-6">
                    <TextArea
                        id="add_sku"
                        label="Add SKU(s)"
                        value={newSku}
                        onChange={(e) => setNewSku(e.target.value)}
                        collapse
                    />
                    <p>
                        <small>Paste or type a comma separated list of SKUs.</small>
                    </p>
                    <button
                        className="button button-secondary"
                        onClick={() => {
                            let _newSkus = splitCSV(newSku);
                            if (!_newSkus.length) return;
                            onChange({
                                sku_list: [...skus, ..._newSkus],
                                ranked: ranked
                            });
                            setNewSku('');
                        }}
                    >
                        Add SKU(s)
                    </button>
                    <button
                        className={classNames('button btn-outline-primary', { active: ranked })}
                        onClick={() => {
                            onChange({ ranked: !ranked });
                        }}
                    >
                        {ranked && <MdStar />} Use Custom Sorting
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SkuListEditor;
